import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useAppState } from '@react-native-community/hooks';
import { useIsFocused } from '@react-navigation/native';
import React, { forwardRef, useEffect, useState } from 'react';
import { ActivityIndicator } from 'react-native';
import Toast from 'react-native-root-toast';
import { Camera, } from 'react-native-vision-camera';
import * as S from './CameraPreview.style';
export default forwardRef(function CameraPreview(props, ref) {
    var _a;
    const [initialized, setInitialized] = useState(false);
    // check if camera page is active
    const isFocused = useIsFocused();
    const appState = useAppState();
    const isActive = isFocused && appState === 'active';
    // 카메라 변경 시 카메라 초기화 진행됨
    useEffect(() => {
        setInitialized(false);
    }, [props.device]);
    function handleCameraError(e) {
        Toast.show(`카메라 오류가 발생했습니다.\n${e.message}`);
    }
    return (_jsxs(_Fragment, { children: [_jsx(Camera, { photo: true, ref: ref, style: { flex: 1 }, device: props.device, isActive: isActive, zoom: (_a = props.device.neutralZoom) !== null && _a !== void 0 ? _a : 1, enableZoomGesture: true, photoQualityBalance: 'speed', androidPreviewViewType: "surface-view", onInitialized: () => {
                    setInitialized(true);
                }, onError: handleCameraError }), !initialized && (_jsx(S.Loading, { children: _jsx(ActivityIndicator, { size: "large" }) }))] }));
});
